export default "__VITE_ASSET__CORPcFz3__"